<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
    <v-layout column class="select-card">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
          <v-data-table hover
            density="compact"
            :search="search"
            v-model="selected"
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            fixed-header
            height="100%" 
            :loading="loading"
            :items-per-page="pageSize"
            return-object
            loading-text="Loading Data... Please wait"
            class="elevation-1" >
            <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }" >
              <span>
                <span v-if="item[header.value] !== null && item[header.value] !== ''">{{ item[header.value] }}</span>
                <span v-else>-</span>
              </span>
            </template>
            <template #bottom></template>
          </v-data-table> 
        </v-col>
      </v-layout>
  </v-card>
</template>
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  export default {
    components: {
      HeaderComponent,
    },
    data() {
      return {
        headerText: "Tour Plan",
        alert: false,
        alert_type: "success",
        alert_message: '',
        selected: [],
        table_data : [],
        managerDetails: [],
        search: '',
        loading: false,
        search_tag: '',
        headers: [
          { title: "Service Manager ID", key: "sales_manager_id" },
          { title: "Service Manager Name", key: "sales_manager" },
          { title: "Month", key: "current_tour_month" },
          { title: "Tour Plan ID", key: "current_tour_id" },
          { title: "Stage", key: "stage" },

        ],
        approveRemarkPopup: false,
        rejectRemarkPopup: false,
        successPopup: false,
        reject_remarks: '',
        add_remarks: '',
        SuccessMessage: '',
      }
    },
    async created() {
      this.tour_id = this.$store.state.lotIds
      this.action = this.$store.state.action
      this.itemsID = this.$store.state.inventoryId
      this.showTourPlan()
    },
    methods: {
      showTourPlan(){
        const params = {
          "id": this.itemsID,
          "sales_manager_id": this.tour_id,
          page: this.page,
          per_page: this.pageSize
        };
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/get_sales_manager_associates_managers', params)
        .then(response => {
          if (response.data) {
            this.table_data = response.data.sales_managers;
            this.totalPages = response.data.meta.total_pages;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", "No Data Found");
        });
      },
      editItems() { 
        if (this.actionDetails === 'sales_manager_wise') {
          this.$router.push({ name: "tourVisit", params: { salesManagerWise: 'sales_manager_wise', method: true }});
        }
        if(this.actionDetails === 'date_wise') {
          this.$router.push({ name: "tourVisit", params: { salesManagerWise: 'date_wise', method: true }});
        }
      },
      getRouterLink() {
        if ( this.action === "Service Manager Approved Tour Plan History") {
          return { name: "tourVisit" };
        }
      },
      getRouterLinkText() {
        return this.action;
      },
      componentsName() {
        if (this.action === "Service Manager Approved Tour Plan History") {
          return this.tour_id;
        }
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      alertTimeOut() {
        setTimeout(() => {this.alert = false;}, 3000);
      },
    }
  }
</script>